const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

// Dynamically load gtag.js only when measurement ID is present
if (GA_ID) {
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID, {
    anonymize_ip: true,
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  });
}

export function trackEvent(eventName, params = {}) {
  if (GA_ID && window.gtag) {
    window.gtag('event', eventName, params);
  }
}

export function trackPageView(path) {
  if (GA_ID && window.gtag) {
    window.gtag('config', GA_ID, { page_path: path });
  }
}
